import React, { Component } from "react"
import styled from "styled-components"
import fonts from "../../styles/fonts"
import Popup from "../Core/Popup"
import breakpoints from "../../styles/breakpoints"
import colors from "../../styles/colors"
import { withTranslation } from "gatsby-plugin-react-i18next"

const ContinueShopping = styled.button`
  cursor: pointer;
  border: 2px solid ${colors.green};
  padding: 19px 40px;
  min-width: 222px;
  min-height: 56px;
  box-sizing: border-box;
  display: inline-block;
  text-align: center;
  ${fonts.helveticaNeueMedium};
  font-size: 12px;
  letter-spacing: 0.82px;
  line-height: 14px;
  color: ${colors.white};
  text-decoration: none;
  text-transform: uppercase;
  background: ${colors.green};
  transition: all 0.5s;
  
  &:hover,
  &:active,
  &:focus {
    color: ${colors.green};
    background-color: ${colors.white};
    text-decoration: none;
    outline: none;
    box-shadow: none;
  }
  
  @media(min-width: ${breakpoints.md}) {
    padding: 19px 60px;
  }
`;

const PopupContent = styled.div`
  text-align: center;
`;

const PopupTitle = styled.h3`
  ${fonts.selfModern};
  font-size: 30px;
  line-height: 28px;
  letter-spacing: 0;
  margin-bottom: 22px;
  
  @media(min-width: ${breakpoints.md}) {
    font-size: 40px;
    line-height: 46px;
    padding-top: 100px;
    margin-bottom: 47px;
  }
`;

class CouponPopup extends Component {
  state = {
    isOpen: true
  };

  closePopup(e) {
    e.preventDefault();

    this.setState({
      isOpen: false
    }, () => {
      this.setState({isOpen: true});
    });
  }

  render() {
    const {handlePopup, open, t, freeGiftActive} = this.props;

    let isOpen = open;

    if (isOpen && this.state.isOpen === false) {
      isOpen = false;
    }

    return (
      <Popup handlePopup={handlePopup} open={isOpen}>
        <PopupContent>
          <PopupTitle>
            {freeGiftActive
              ? t("minicart.promo_code.free_gift_active")
              : t("bag.promo_code_not_valid")}
          </PopupTitle>
          <ContinueShopping onClick={(e) => this.closePopup(e)}>
            {t("core.continue_shopping")}
          </ContinueShopping>
        </PopupContent>
      </Popup>
    )
  }
}

export default withTranslation()(CouponPopup);
